import { render, staticRenderFns } from "./i8-quote.vue?vue&type=template&id=1185b78a&functional=true&%3Aclass=%5Bdata.class%2C%20data.staticClass%5D"
import script from "./i8-quote.vue?vue&type=script&lang=ts"
export * from "./i8-quote.vue?vue&type=script&lang=ts"
import style0 from "./i8-quote.vue?vue&type=style&index=0&id=1185b78a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports